import Panel from './Panel.js';
import mapboxgl from 'mapbox-gl';
import FormEndpoint from './FormEndpoint.js';

/**
 * Popin Newsletter class.
 */
export default class PanelPickup extends Panel {
  maxDistance = 100;

  static config = {
    name: 'PanelPickup',
    refs: ['form', 'input', 'stores[]', 'noresults', 'reset', 'error', ...Panel.config.refs],
    components: {
      FormEndpoint,
    },
    options: {
      url: String,
    },
  };

  /**
   * Get input value
   * @returns {string}
   */
  get inputValue() {
    return this.$refs.input.value;
  }

  /**
   * Mount component
   */
  mounted() {
    super.mounted();

    this.locations = this.$refs.stores.map((store) => ({
      element: store,
      name: store.dataset.name,
      coords: [Number.parseFloat(store.dataset.lng), Number.parseFloat(store.dataset.lat)],
    }));
  }

  /**
   * Prevent Form Submit and Fetch address
   * @param {object} props
   * @param {Event} props.event
   */
  onFormSubmit({ event }) {
    event.preventDefault();

    if (this.inputValue) {
      this.fetchAddress();
      this.$refs.reset.classList.remove('hidden');
    }
  }

  /**
   *
   */
  onResetClick() {
    this.$refs.input.value = '';
    this.$refs.noresults.classList.add('hidden');
    this.$refs.error.classList.add('hidden');
    this.$refs.reset.classList.add('hidden');
    this.resetStores();
  }

  /**
   *
   */
  onInputInput() {
    if (this.inputValue === '') {
      this.$refs.reset.classList.add('hidden');
    }
  }

  /**
   *
   */
  async fetchAddress() {
    const geocodeUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(this.inputValue)}.json?access_token=${this.$options.url}`;
    const response = await fetch(geocodeUrl);
    const data = await response.json();

    const nearestStores = [];
    this.$refs.noresults.classList.add('hidden');
    this.$refs.error.classList.add('hidden');
    this.$refs.reset.classList.remove('hidden');

    if (!data.features || data.features.length === 0) {
      this.$refs.error.classList.remove('hidden');
      return;
    }

    const userLocation = mapboxgl.LngLat.convert(data.features[0].geometry.coordinates);

    this.locations.forEach((loc) => {
      const storeLocation = mapboxgl.LngLat.convert(loc.coords);
      const dist = userLocation.distanceTo(storeLocation) / 1000; // Convertir en kilomètres
      loc.distance = dist;

      if (dist <= this.maxDistance) {
        loc.element.classList.remove('hidden');
        nearestStores.push(loc);
      } else {
        loc.element.classList.add('hidden');
      }
    });

    nearestStores.sort((a, b) => a.distance - b.distance);

    if (nearestStores || length <= 1) {
      nearestStores.forEach((store, index) => {
        store.element.classList.remove('hidden');
        store.element.style.order = index;
      });
    } else {
      this.$refs.noresults.classList.remove('hidden');
      this.resetStores();
    }
  }

  /**
   *
   */
  resetStores() {
    this.$refs.stores.forEach((element) => {
      element.classList.remove('hidden');
      element.style.order = '';
    });
  }
}
